import React from "react";
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";

import FavoriteIcon from "@material-ui/icons/Favorite"; // heart icon
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

const useStyles = makeStyles(styles);

export default function RegisterSuccessPage({ history }) {
  const [cardAnimation, setCardAnimation] = React.useState("cardHidden");

  React.useEffect(() => {
    const id = setTimeout(() => setCardAnimation(""), 700);
    return () => clearTimeout(id);
  }, []);

  const classes = useStyles();

  const handleLoginRedirect = () => {
    history.push("/auth/verify-email");
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={6}>
          <Card className={classes[cardAnimation]}>
            <CardHeader
              className={`${classes.cardHeader} ${classes.textCenter}`}
              color="rose"
            >
              <FavoriteIcon style={{ fontSize: 40, color: "#fff" }} />
              <h4 className={classes.cardTitle}>
                Your registration was successful 💕
              </h4>
            </CardHeader>
            <CardBody className={classes.textCenter}>
              <h5>Verify your email address</h5>
              <p>Before you proceed kindly verify your email address</p>
            </CardBody>
            <CardFooter className={classes.justifyContentCenter}>
              <Button color="rose" onClick={handleLoginRedirect}>
                Click here to proceed
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
